// src/pages/About.jsx
import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const About = () => {
  return (
    <Container
      maxWidth="md"
      sx={{
        my: 4,
        px: { xs: 2, sm: '5vw', md: '7vw' },
      }}
    >
      <Box sx={{ textAlign: 'center', mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, color: 'primary.main' }}>
          About Us
        </Typography>
        <Typography variant="subtitle1" sx={{ color: 'text.secondary', mt: 1 }}>
          Our Journey and Mission
        </Typography>
      </Box>

      <Box>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Welcome to Our Company! We are passionate about delivering high-quality products and providing exceptional customer service. Founded in [Year], our company has grown rapidly by focusing on innovation and a commitment to excellence.
        </Typography>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Our mission is to create a seamless shopping experience that meets the needs of our diverse customer base. We continuously strive to improve our offerings and ensure every interaction with our brand is a positive one.
        </Typography>
        <Typography variant="body1">
          Thank you for choosing us. We look forward to serving you and making your experience truly memorable.
        </Typography>
      </Box>
    </Container>
  );
};

export default About;
